import {
  Error,
  ADD_ATTEND_EMP,
  ADD_REQUEEST_EMP,
  GET_ATTEND_EMP,
  GET_REQUEST_EMP,
} from "../type";
const initialState = {
  AddATTENDEMP: [],
  AddREQUESTEMP: [],
  GetREQUESTEMP: [],
  GetATTENDEMP: [],
};
const EmployeePageR = (state = initialState, action) => {
  switch (action.type) {
    case GET_ATTEND_EMP:
      return {
        ...state,
        GetATTENDEMP: action.payload,
      };
    case GET_REQUEST_EMP:
      return {
        ...state,
        GetREQUESTEMP: action.payload,
      };
    case ADD_ATTEND_EMP:
      return {
        GetATTENDEMP: state.GetATTENDEMP,
        AddATTENDEMP: action.payload,
      };
    case ADD_REQUEEST_EMP:
      return {
        GetREQUESTEMP: state.GetREQUESTEMP,
        AddREQUESTEMP: action.payload,
      };
    case Error:
      return {
        GetATTENDEMP: action.payload,
      };
    default:
      return state;
  }
};
export default EmployeePageR;
